import React from 'react';

type LogoProps = {
  className?: string;
  variant?: 'full' | 'mark';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  forceWhite?: boolean;
  /** Show the "ARTISTIC INTELLIGENCE" tagline next to the wordmark */
  showTagline?: boolean;
};

export function Logo({ className = '', variant = 'full', size = 'md', forceWhite = false, showTagline = false }: LogoProps) {
  const sizeMap = {
    sm: { h: 'h-6', text: 'text-[14px]', tagText: 'text-[9px]' },
    md: { h: 'h-7', text: 'text-[16px]', tagText: 'text-[10px]' },
    lg: { h: 'h-8', text: 'text-[18px]', tagText: 'text-[11px]' },
    xl: { h: 'h-10', text: 'text-[22px]', tagText: 'text-[12px]' },
  };

  const { h, text, tagText } = sizeMap[size];
  const outerColor = forceWhite ? '#ffffff' : '#171717';
  const innerColor = forceWhite ? 'rgba(255,255,255,0.3)' : '#F7F5F3';
  const textColor = forceWhite ? '#ffffff' : '#171717';
  const taglineColor = forceWhite ? 'rgba(255,255,255,0.6)' : '#737373';
  const dividerColor = forceWhite ? 'rgba(255,255,255,0.2)' : '#E3E1DD';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Mark — square within a square */}
      <svg
        viewBox="0 0 24 24"
        className={`${h} aspect-square flex-shrink-0`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0" y="0" width="24" height="24" rx="5" fill={outerColor} />
        <rect x="6" y="6" width="12" height="12" rx="4" fill={innerColor} />
      </svg>

      {/* Wordmark */}
      {variant === 'full' && (
        <div className="flex items-center gap-2">
          <span
            className={`font-semibold uppercase tracking-wide ${text}`}
            style={{ fontFamily: 'Inter,system-ui,sans-serif', color: textColor, letterSpacing: '0.04em' }}
          >
            Cascady
          </span>

          {showTagline && (
            <>
              <div className="self-stretch w-px" style={{ background: dividerColor }} />
              <div className={`${tagText} leading-tight uppercase`} style={{ fontFamily: 'Inter,system-ui,sans-serif', color: taglineColor, letterSpacing: '0.02em' }}>
                <div>Artistic</div>
                <div>Intelligence</div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
